"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[19843],{

/***/ 18160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

function e(e){return e&&"object"==typeof e&&"default"in e?e.default:e}var t=__webpack_require__(67294),a=e(t),n=e(__webpack_require__(45697)),l=e(__webpack_require__(73935)),r=__webpack_require__(70880);function o(){return(o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var a=arguments[t];for(var n in a)Object.prototype.hasOwnProperty.call(a,n)&&(e[n]=a[n])}return e}).apply(this,arguments)}function i(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(e)))return;var a=[],n=!0,l=!1,r=void 0;try{for(var o,i=e[Symbol.iterator]();!(n=(o=i.next()).done)&&(a.push(o.value),!t||a.length!==t);n=!0);}catch(e){l=!0,r=e}finally{try{n||null==i.return||i.return()}finally{if(l)throw r}}return a}(e,t)||function(e,t){if(!e)return;if("string"==typeof e)return c(e,t);var a=Object.prototype.toString.call(e).slice(8,-1);"Object"===a&&e.constructor&&(a=e.constructor.name);if("Map"===a||"Set"===a)return Array.from(e);if("Arguments"===a||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a))return c(e,t)}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function c(e,t){(null==t||t>e.length)&&(t=e.length);for(var a=0,n=new Array(t);a<t;a++)n[a]=e[a];return n}function s(e){var t=e.className,n=e.children,l=e.type,r=e.value,o=e.invalid,i=e.onChange,c="form-control-sm form-control ";return o&&(c+="is-invalid "),t&&(c+=t),"select"===l?a.createElement("select",{className:c,value:r,onChange:function(e){return i(e.target.value)}},n):"textarea"===l?a.createElement("textarea",{className:c,value:r,onChange:function(e){return i(e.target.value)}}):a.createElement("input",{className:c,autoFocus:!0,type:l,value:r,onChange:function(e){return i(e.target.value,e)}})}function u(e){var t=e.validationText,n=e.value,l=e.setNewValue,r=e.controls;return a.createElement(a.Fragment,null,a.createElement(s,{className:"mr-1",type:"text",value:n||"",onChange:l,invalid:!!t}),r)}function m(e){var t=e.validationText,n=e.value,l=e.setNewValue;return a.createElement(a.Fragment,null,a.createElement(s,{className:"mb-1",invalid:!!t,value:n||"",onChange:l,type:"textarea"}))}function d(e){var t=e.value,n=e.setNewValue,l=e.controls,r=e.options.map((function(e,t){return a.createElement("option",{key:t+e},e)}));return a.createElement(a.Fragment,null,a.createElement(s,{value:t,onChange:n,type:"select",className:"mr-1"},r),l)}function f(e){var t=e.value,n=e.setNewValue,l=e.controls,r=t;if(r)if(r.toISOString)r=r.toISOString().slice(0,10);else try{r=new window.Date(r).toISOString().slice(0,10)}catch(e){console.error("Unable to parse provided date value to Date object: ".concat(e.message))}return a.createElement(a.Fragment,null,a.createElement(s,{value:r||"",type:"date",className:"mr-1",onChange:function(e,t){return n(t.target.valueAsDate)}}),l)}function p(e){var n=e.isOpen,o=e.triggerElement,c=e.placement,s=e.children,u=i(t.useState(null),2),m=u[0],d=u[1],f=r.usePopper(o.current,m,{placement:c}),p=f.styles,v=f.state,E=a.createElement("div",{className:"bs-popover-auto popover",ref:d,style:p.popper,"x-placement":null==v?void 0:v.placement},a.createElement("div",{className:"arrow","data-popper-arrow":!0,style:p.arrow}),a.createElement("div",{className:"popover-inner",role:"tooltip"},a.createElement("h3",{className:"popover-header"},s[0]),a.createElement("div",{className:"popover-body"},s[1])));return n?l.createPortal(E,document.getElementsByTagName("body")[0]):null}function v(e){var t=e.value,n=e.setNewValue,l=e.controls,r=e.label;return a.createElement(a.Fragment,null,a.createElement("div",{className:"custom-file"},a.createElement("input",{type:"file",className:"custom-file-input mr-1",onChange:function(e){return n(e.target.files[0])}}),a.createElement("label",{className:"custom-file-label"},t?t.name:r)),l)}var E={textAlign:"center",width:"1.25em",height:"1em",fill:"white",verticalAlign:"-0.25em"};function b(e){var n=i(t.useState(e.initialValue),2),l=n[0],r=n[1],c=i(t.useState(e.initialValue),2),s=c[0],b=c[1],g=i(t.useState(!1),2),y=g[0],h=g[1],w=i(t.useState(null),2),x=w[0],N=w[1],S=i(t.useState(!1),2),C=S[0],V=S[1],j=t.useRef(null);function O(){var t=a.createElement("button",{className:"btn btn-success btn-sm ml-auto mr-1"},a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 512 512",style:E},a.createElement("path",{color:"white",d:"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"}))),n=a.createElement("button",{className:"btn btn-danger btn-sm",onClick:k},a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 352 512",style:E},a.createElement("path",{d:"M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"})));a.isValidElement(e.renderConfirmElement)&&(t=a.cloneElement(e.renderConfirmElement,{onClick:T})),a.isValidElement(e.renderCancelElement)&&(n=a.cloneElement(e.renderCancelElement,{onClick:function(e){e.preventDefault(),k()}}));var l=a.createElement(a.Fragment,null,t,n);C&&(l=a.createElement("div",{className:"my-auto mx-4"},a.createElement("div",{className:"spinner-border",style:{width:"1.5rem",height:"1.5rem"}})));var r,i={value:s,validationText:x,controls:l,setNewValue:b,onCancel:k};switch(e.type){case"textfield":r=a.createElement(u,i);break;case"select":r=a.createElement(d,o({},i,{options:e.options}));break;case"date":r=a.createElement(f,i);break;case"textarea":return a.createElement("form",{onSubmit:T},a.createElement(m,i),a.createElement("div",{className:"d-flex align-items-start"},a.createElement("small",{className:"mt-0 form-text text-muted"},x),l));case"file":r=a.createElement(v,o({},i,{label:e.label}));break;default:return console.error("Editable(".concat(e.id,'): "').concat(e.type,'" is not a valid value for the "type" prop')),null}return a.createElement("form",{onSubmit:T,className:e.className},a.createElement("div",{className:"align-items-baseline d-flex"},r),a.createElement("small",{className:"mt-0 form-text text-muted"},x))}function T(t){t.preventDefault(),function(t){var a=e.validate?e.validate(t):null;e.onSubmit&&e.onSubmit(t),a?N(a):e.validate?function(t){e.onValidated?e.onValidated(t):e.ajax||console.error("Editable(".concat(e.id,"): Specified a validate function without onValidated or ajax"));e.ajax&&t!==l?function(t){V(!0);var a=new XMLHttpRequest;e.ajax(a,t,e.id);var n=a.onreadystatechange?a.onreadystatechange:null;a.onreadystatechange=function(){n&&n(),4===a.readyState&&(200===a.status?(h(!1),r(t),N(null)):N("Ajax Response ".concat(a.status," Error")),V(!1))}}(t):(r(t),h(!1),N(null))}(t):(r(t),h(!1))}(s)}function k(){N(null),b(l),h(!1)}if(t.useEffect((function(){!e.ajax||e.validate||e.disabled||console.error("Editable(".concat(e.id,"): You provided an ajax prop without a validate prop;\n            ajax function will not be called"))}),[]),t.useEffect((function(){r(e.initialValue),b(e.initialValue)}),[e.initialValue]),(y||e.alwaysEditing)&&"inline"===e.mode)return O();var A=l||"No value";A="date"===e.type&&l?new window.Date(l).toUTCString().slice(5,16):l,A="file"===e.type&&l?l.name:A;var q="",D="";e.isValueClickable?e.disabled?q=A:D=A:(q=A,D=e.disabled?D:e.editText),q=e.label?"".concat(e.label,": ").concat(q):q;var F="popover"===e.mode?a.createElement(p,{isOpen:y,placement:e.placement,triggerElement:j},e.label,O()):null;return a.createElement("form",{className:"form-inline ".concat(e.className)},q&&e.showText&&a.createElement("p",{className:"my-0",style:{whiteSpace:"pre-wrap"}},q),D&&a.createElement("a",{ref:j,className:"ml-1 mt-auto",href:"#",onClick:function(e){e.preventDefault(),h(!0)}},D),F)}b.defaultProps={type:"textfield",mode:"inline",alwaysEditing:!1,className:null,initialValue:null,id:null,label:null,showText:!0,disabled:!1,isValueClickable:!1,editText:"Edit",renderConfirmElement:null,renderCancelElement:null,placement:"top",validate:null,ajax:null,onSubmit:null,onValidated:null,options:null},b.propTypes={type:n.oneOf(["textfield","textarea","select","date","file"]).isRequired,mode:n.oneOf(["inline","popover"]).isRequired,alwaysEditing:n.bool,className:n.string,initialValue:n.oneOfType([n.string,n.instanceOf(f)]),id:n.oneOfType([n.string,n.number]),label:n.string,showText:n.bool,disabled:n.bool,isValueClickable:n.bool,editText:n.string,renderConfirmElement:n.element,renderCancelElement:n.element,validate:n.func,ajax:n.func,onSubmit:n.func,onValidated:n.func,placement:n.oneOf(["auto","auto-start","auto-end","top","top-start","top-end","right","right-start","right-end","bottom","bottom-start","bottom-end","left","left-start","left-end"]),options:n.array},module.exports=b;
//# sourceMappingURL=editable.js.map


/***/ }),

/***/ 70880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Manager": function() { return /* reexport */ Manager; },
  "Popper": function() { return /* reexport */ Popper; },
  "Reference": function() { return /* reexport */ Reference; },
  "usePopper": function() { return /* reexport */ usePopper; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap-editable/node_modules/react-popper/lib/esm/Manager.js

var ManagerReferenceNodeContext = react.createContext();
var ManagerReferenceNodeSetterContext = react.createContext();
function Manager(_ref) {
  var children = _ref.children;

  var _React$useState = react.useState(null),
      referenceNode = _React$useState[0],
      setReferenceNode = _React$useState[1];

  var hasUnmounted = react.useRef(false);
  react.useEffect(function () {
    return function () {
      hasUnmounted.current = true;
    };
  }, []);
  var handleSetReferenceNode = react.useCallback(function (node) {
    if (!hasUnmounted.current) {
      setReferenceNode(node);
    }
  }, []);
  return /*#__PURE__*/react.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /*#__PURE__*/react.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: handleSetReferenceNode
  }, children));
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap-editable/node_modules/react-popper/lib/esm/utils.js


/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? react.useLayoutEffect : react.useEffect;
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/createPopper.js + 6 modules
var createPopper = __webpack_require__(45704);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
var eventListeners = __webpack_require__(82372);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js
var popperOffsets = __webpack_require__(77421);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js
var computeStyles = __webpack_require__(36531);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
var getNodeName = __webpack_require__(96333);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
var instanceOf = __webpack_require__(62556);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!(0,instanceOf/* isHTMLElement */.Re)(element) || !(0,getNodeName/* default */.Z)(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!(0,instanceOf/* isHTMLElement */.Re)(element) || !(0,getNodeName/* default */.Z)(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect,
  requires: ['computeStyles']
});
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js
var offset = __webpack_require__(82122);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js + 3 modules
var flip = __webpack_require__(68855);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js + 1 modules
var preventOverflow = __webpack_require__(394);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js
var arrow = __webpack_require__(66896);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js
var hide = __webpack_require__(19892);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners/* default */.Z, popperOffsets/* default */.Z, computeStyles/* default */.Z, modifiers_applyStyles, offset/* default */.Z, flip/* default */.Z, preventOverflow/* default */.Z, arrow/* default */.Z, hide/* default */.Z];
var popper_createPopper = /*#__PURE__*/(0,createPopper/* popperGenerator */.kZ)({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


// EXTERNAL MODULE: ./node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__(69590);
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap-editable/node_modules/react-popper/lib/esm/usePopper.js





var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = react.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = react.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = react.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        react_dom.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = react.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (react_fast_compare_default()(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = react.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper = options.createPopper || popper_createPopper;
    var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};
;// CONCATENATED MODULE: ./node_modules/react-bootstrap-editable/node_modules/react-popper/lib/esm/Popper.js





var NOOP = function NOOP() {
  return void 0;
};

var NOOP_PROMISE = function NOOP_PROMISE() {
  return Promise.resolve(null);
};

var Popper_EMPTY_MODIFIERS = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? Popper_EMPTY_MODIFIERS : _ref$modifiers,
      referenceElement = _ref.referenceElement,
      onFirstUpdate = _ref.onFirstUpdate,
      innerRef = _ref.innerRef,
      children = _ref.children;
  var referenceNode = react.useContext(ManagerReferenceNodeContext);

  var _React$useState = react.useState(null),
      popperElement = _React$useState[0],
      setPopperElement = _React$useState[1];

  var _React$useState2 = react.useState(null),
      arrowElement = _React$useState2[0],
      setArrowElement = _React$useState2[1];

  react.useEffect(function () {
    setRef(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = react.useMemo(function () {
    return {
      placement: placement,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: 'arrow',
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);

  var _usePopper = usePopper(referenceElement || referenceNode, popperElement, options),
      state = _usePopper.state,
      styles = _usePopper.styles,
      forceUpdate = _usePopper.forceUpdate,
      update = _usePopper.update;

  var childrenProps = react.useMemo(function () {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return unwrapArray(children)(childrenProps);
}
// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__(42473);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap-editable/node_modules/react-popper/lib/esm/Reference.js




function Reference(_ref) {
  var children = _ref.children,
      innerRef = _ref.innerRef;
  var setReferenceNode = react.useContext(ManagerReferenceNodeSetterContext);
  var refHandler = react.useCallback(function (node) {
    setRef(innerRef, node);
    safeInvoke(setReferenceNode, node);
  }, [innerRef, setReferenceNode]); // ran on unmount
  // eslint-disable-next-line react-hooks/exhaustive-deps

  react.useEffect(function () {
    return function () {
      return setRef(innerRef, null);
    };
  }, []);
  react.useEffect(function () {
    warning_default()(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
  }, [setReferenceNode]);
  return unwrapArray(children)({
    ref: refHandler
  });
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap-editable/node_modules/react-popper/lib/esm/index.js
// Public components




 // Public types

/***/ })

}]);